import { Component, OnInit, ViewChild, ElementRef, Renderer2, ChangeDetectorRef } from "@angular/core";
import { DatePipe } from '@angular/common';
import { Router, ActivatedRoute } from "@angular/router";
import { LazyLoadEvent, MenuItem } from "primeng/api";
import { QuestionService } from "src/app/manage/questionanswer/service/question.service";
import { UserContestService } from "src/app/services/usercontest.service";
import { ContestService } from "src/app/services/contest.service";
import { environment } from "src/environments/environment";
import { TokenStorageService } from "src/app/services/token-storage.service";
import { ConfirmationService, MessageService, ConfirmEventType } from "primeng/api";
import { RoleService } from "src/app/services/role.service";
import { HttpClient } from "@angular/common/http";
import { HeaderComponent } from "../header/header.component";
import { UserService } from "src/app/services/user.service";
import { CommonService } from "../../services/common.service";
interface deleteItems {
  name: string,
  code: string
}
import {
  FormBuilder,
  FormGroup,
  FormControl,
  Validators,
  FormsModule,
} from "@angular/forms";
import { CountryService } from "src/app/manage/country/service/country.service";
import { StateService } from "src/app/manage/state/service/state.service";
import { CityService } from "src/app/manage/city/service/city.service";
import { ScheduleService } from "src/app/services/schedule.service";
import * as moment from "moment";
import { TitleCasePipe } from "@angular/common";
import { FullCalendarComponent } from "@fullcalendar/angular";
import { EventService } from "src/app/demo/service/eventservice";
@Component({
  selector: "app-my-schedule",
  templateUrl: "./my-schedule.component.html",
  styleUrls: ["./my-schedule.component.scss"],
  providers: [
    HeaderComponent,
    MessageService,
    ConfirmationService,
    TitleCasePipe,
    DatePipe
  ],
})
export class MyScheduleComponent implements OnInit {
  deleteItems!: deleteItems[];

  selectedCities!: deleteItems[];
  visible: boolean = false;
  position: string = 'center';
  items: MenuItem[];
  public options;
  public selectedCityId;
  public loading: boolean;
  mobileCalender: boolean = false;
  public errorMessage: string;
  public totalRecords = 0;
  public showCreateScheduleForm: boolean = false;
  public contestUserList: any[] = [];
  carouselResponsiveOptions: any[] = [
    {
      breakpoint: "1024px",
      numVisible: 12,
      numScroll: 12,
      margin: 20,
    },
    {
      breakpoint: "768px",
      numVisible: 2,
      numScroll: 2,
      margin: 20,
    },
    {
      breakpoint: "560px",
      numVisible: 1,
      numScroll: 1,
    },
  ];
  @ViewChild("prevButton") prevButton: ElementRef;
  @ViewChild("nextButton") nextButton: ElementRef;
  @ViewChild("calendar") calendarComponent: FullCalendarComponent;
  lazyLoadEvent: LazyLoadEvent;
  public pagination = environment.pagination;
  public mode = "";
  loggedInUser: any;
  isLoggedIn: boolean = false;
  loginRegisterModal: boolean = false;
  showMessage: boolean = false;
  userType;
  userData;
  isLoginFailed: boolean;
  selectedCityName: any;

  recurring: any;
  roles;
  trainerRoleId;
  permissions: any[] = [];
  permissionArray: any[] = [];
  userTypeListArray: any[] = [];
  rolelist: any[] = [];
  public date: Date;
  public countryName;
  public countryCode;
  public countryList: any = [];
  public stateList: any = [];
  public stateCode;
  public stateName;
  public description;
  public cityList: any = [];
  public config = {
    allowNumbersOnly: true,
    length: 6,
    isPasswordInput: false,
    disableAutoFocus: false,
    required: true,
    placeholder: "",
    inputStyles: {
      width: "50px",
      height: "50px",
    },
  };
  public userId;
  public contestId: any;
  public showJoinContestMessage: boolean = false;
  public isAdd: boolean = true;
  public scheduleForm: FormGroup;
  public defaultDate: Date = new Date();
  public mDate: Date = new Date();
  public minDate: Date = new Date();
  public recurringArray = environment.recurringArray;
  public amenitiesArray = environment.amenitiesArray;
  public selectedRecurringOptions: any = [];
  public selectedAmenities: any = [];
  public scheduleList: any = [];
  public cityCode: any;
  public cityName: any;
  public state: any;
  public submitted: boolean = false;
  public scheduleId;
  public scheduleDetails;
  public recurringDisabled: boolean = true;
  public ament: any[];
  public minTime;
  public selectedDate: any;
  public SelectedDate: string;
  public scheduleListArr: any = [];
  public scheduleHistoryListArr: any = [];

  public events: any = [];
  public scheduleListArray: any = [];
  public viewOptions;
  onPageChangeTriggered: boolean = true;
  header: string;
  utcDateTime: string;
  public roleName: string;
  public showCreateSchedule: boolean = false;
  dateclicked: boolean = false;
  messageConfirmation: string = "Are sure you want to delete this sessions ?";
  everyWeek: boolean = false;
  everyMonth: boolean = false;
  deleteSheduleModal: boolean = false;
  scheduleDataDetails: any;
  startDates: string;
  showDescription: boolean;
  showMore = false;
  selectedScheduleId: string;
  constructor(
    private questionService: QuestionService,
    private userContestService: UserContestService,
    private contestService: ContestService,
    private router: Router,
    private roleService: RoleService,
    private http: HttpClient,
    private userService: UserService,
    private tokenStorage: TokenStorageService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private ActiveRoute: ActivatedRoute,
    private formBuilder: FormBuilder,
    private countryService: CountryService,
    private stateService: StateService,
    private cityService: CityService,
    private scheduleService: ScheduleService,
    private titleCasePipe: TitleCasePipe,
    private commonService: CommonService,
    private eventService: EventService,
    private datePipe: DatePipe,
    private renderer: Renderer2,
    private cdr: ChangeDetectorRef,


  ) {
    this.deleteItems = [
      { name: 'Every Week', code: 'AU' },
      { name: 'Every Month', code: 'BR' },
      { name: 'All Sessions', code: 'CN' },

    ];
  }
  ngOnInit(): void {
    this.roleService.setCurrentActiveRoute(this.router.url);
    const localStartdate = localStorage.getItem("startDate");
    const existingStartDate = localStartdate && JSON.parse(localStartdate);
    if (existingStartDate === null) {
      this.scheduleService.findPartnerStartDate.subscribe((startDate) => {
        localStorage.setItem("startDate", JSON.stringify(startDate));
        this.startDates = startDate;
      })
    } else {
      localStorage.setItem("startDate", JSON.stringify(existingStartDate));
      this.startDates = existingStartDate;
    }

    this.router.events.subscribe((res) => {
      localStorage.removeItem("startDate");
    })


    this.renderer.addClass(document.body, 'my-schedule-page');
    this.loggedInUser = this.tokenStorage.getUser();
    if (this.loggedInUser.userdata != undefined) {
      this.userId = this.loggedInUser.userdata.id;
      this.isLoggedIn = true;
      this.contestId = this.ActiveRoute.snapshot.params.userContestId;
      this.roleName = this.loggedInUser.userdata.rolename;
      if (this.roleName == "player" || this.roleName == "proplayer" || this.roleName == "coach") {
        this.showCreateSchedule = true;
      } else {
        this.showCreateSchedule = false;
      }
      this.roleName = this.loggedInUser.userdata.rolename;
      if (this.roleName == "proplayer" || this.roleName == "coach") {
        this.showDescription = true;
      } else {
        this.showDescription = false;
      }
    }
    this.scheduleHistory();
    this.events = [];
    this.scheduleForm = this.formBuilder.group({
      date: ["", [Validators.required]],
      time: ["", [Validators.required]],
      charges: [null, [Validators.required, Validators.min(100)]],
      //country: ['', [Validators.required]],
      state: ["", [Validators.required]],
      city: ["", [Validators.required]],
      venue: ["", [Validators.required]],
      description: [""],

    });
    if (this.isLoggedIn == false) {
      this.router.navigate(["/"]);
    }
    // this.items = [
    //   { routerLink: "/", label: "Home" },
    //   { label: "My Schedule" }
    // ];
    let date = new Date();
    this.selectedDate = moment(date).format("YYYY-MM-DD");

    // this.getCountries();
    // this.getOnlyState();
    this.getStates();

    this.getScheduleList(this.lazyLoadEvent);

    this.recurringArray.forEach((element) => {
      this.scheduleForm.addControl(element.slug, new FormControl());
    });

    this.amenitiesArray.forEach((element) => {
      element["selected"] = false;
      this.scheduleForm.addControl(element.slug, new FormControl());
    });
    this.minTime = moment(this.mDate).add(2, "hours").local().format();
    this.minTime = new Date(this.minTime);
    this.loadViewCalendar();
    console.log(this.messageConfirmation)

  }
  ngOnDestroy() {
    this.renderer.removeClass(document.body, 'my-schedule-page');
  }
  get f() {
    return this.scheduleForm.controls;
  }
  convertToClientTimezone(utcDateTime: string): string {
    // Parse UTC date string to a Date object
    const utcDate = new Date(utcDateTime);

    // Use DatePipe to format the date in the client's timezone
    const clientTimezoneDateTime = this.datePipe.transform(utcDate, 'medium');

    return clientTimezoneDateTime;
  }
  loadViewCalendar() {
    let startYearDate = moment().startOf("year").format("YYYY-MM-DD");
    let sDate = new Date(startYearDate);
    let endDate = moment(sDate).add(2, "year").format("YYYY-MM-DD");
    let edate = new Date(endDate);
    let time = edate.getTime() - sDate.getTime();
    let days = time / (1000 * 3600 * 24); //Diference in Days
    // console.log('days', days);
    // return;
    this.eventService.getEvents().then((events) => {
      events = [];
      this.events = events;
      let query =
        "?filterByDisable=false&filterByStatus=true&filterByBookingStatus=Pending&filterByUserId=" +
        this.userId;
      this.scheduleService.getScheduleList(query).subscribe(
        (response) => {

          this.scheduleListArr = response.data.items;

          if (this.scheduleListArr.length > 0) {

            this.scheduleListArr.forEach((element) => {
              let startDate = moment(element["startDate"]).utc();

              let slotStartHours = moment(element["startDate"]).hours();
              let slotStartMinutes = moment(element["startDate"]).minutes();
              let slotEndHours = moment(element["endDate"]).hours();
              let slotEndMinutes = moment(element["endDate"]).minutes();

              let scheduleDataObj = {
                id: element.id,
                startDate: element.startDate,
                endDate: element.endDate,
                slotStartHours: slotStartHours,
                slotStartMinutes: slotEndMinutes,
                slotEndHours: slotEndHours,
                slotEndMinutes: slotEndMinutes,
              };
              this.scheduleListArray.push(scheduleDataObj);
              if (element.amenities.length > 0) {
                // element['amenities'];
                this.ament = [];
                element.amenities.forEach((aElement) => {
                  this.amenitiesArray.forEach((element) => {
                    if (element.slug == aElement.slug) {
                      this.ament.push(element.name);
                      let obj = {
                        slug: element.slug,
                        status: true,
                      };
                      this.selectedAmenities.push(obj);
                    }
                  });
                });
                element["ament"] = this.ament;
              }

              this.selectedAmenities = [];
            });
          }
          this.scheduleListArray.forEach((schedule) => {
            for (let i = 0; i <= days; i++) {
              let date = moment(sDate).add(i, "days").format("YYYY-MM-DD"); //To set date in calendar date format should be 'YYYY-MM-DD'
              let newStartDate = new Date(sDate);
              newStartDate.setHours(schedule.slotStartHours);
              newStartDate.setMinutes(schedule.slotEndMinutes);
              //let newSDate = moment(newStartDate).add(i, 'days').format('YYYY-MM-DD HH:mm');
              let newEndDate = new Date(sDate);
              newEndDate.setHours(schedule.slotEndHours);
              newEndDate.setMinutes(schedule.slotEndMinutes);
              let newSDate = moment(newStartDate)
                .add(i, "days")
                .format("YYYY-MM-DD");
              let newEDate = moment(newEndDate)
                .add(i, "days")
                .format("YYYY-MM-DD");
              if (date === moment(schedule.startDate).format("YYYY-MM-DD")) {

                if (date === moment(this.startDates).format("YYYY-MM-DD")) {
                  this.events.push({
                    id: schedule.id,
                    // title: moment(schedule.startDate).format('h:mm a'),
                    // classNames: "view",
                    start: newSDate,
                    end: newEDate,
                    color: '"+Cor+"',
                    classNames: "view-schedule",
                    // textColor: '#378006',
                    // display: 'background'
                  });
                } else {
                  this.events.push({
                    id: schedule.id,
                    // title: moment(schedule.startDate).format('h:mm a'),
                    // classNames: "view",
                    start: newSDate,
                    end: newEDate,
                    classNames: ['all-schedules', '#fff'],
                    // color: "#20b033",
                    // textColor: '#378006',
                    // display:'background'

                  });
                }
                //let slotTime = moment(schedule.slotdate).local().format("h:mm a") + " - " + moment(schedule.sessionenddate).local().format("h:mm a");
                // this.events.push({
                //   id: schedule.id,
                //   // title: moment(schedule.startDate).local().format("h:mm a"),
                //   classNames: "view",
                //   start: newSDate,
                //   end: newEDate,
                //   color: "#08b394",
                // });
                //date = moment(startYearDate).add(i, 'days').format('YYYY-MM-DD');
              }
            }
          });
          this.scheduleListArray = [];
          console.log(this.options, 'options')
          this.options = {
            ...this.options,
            ...{ events: events },
            eventContent: function (info) { },
          };
        },
        (error) => { }
      );
    }); 0
    this.options = {

      //initialDate: this.minTime,
      // headerToolbar: {
      //   left: 'prev,next today',
      //   center: 'title',
      //   right: 'dayGridMonth,timeGridWeek,timeGridDay'
      // },
      initialDate: this.startDates,

      eventTextColor: 'red',
      editable: false,
      selectable: true,
      eventOrder: 'displayOrder',
      dateClick: (info) => {
        this.selectedAmenities = []
        this.dateclicked = true
        this.selectedDate = info.dateStr;
        this.startDates = info.dateStr;
        console.log(this.startDates);

        this.getScheduleList(this.lazyLoadEvent);
      },
      selectMirror: true,
      allDaySlot: false,
      showNonCurrentDates: false,
    };
    // Reset selectedAmenities to an empty array
  }
  // getCountries() {
  //   let query = "filterByDisable=false&filterByStatus=true";
  //   this.countryService.getcountryList(query).subscribe(
  //     (data) => {
  //       console.log("this.countryList---", this.countryList);
  //       if (data.data.items.length > 0) {
  //         data.data.items.forEach((element) => {
  //           let countryObj = {
  //             name: element.name,
  //             iso2: element.iso2,
  //           };
  //           this.countryList.push(countryObj);
  //         });
  //         this.countryList.forEach((element) => {
  //           if (element.iso2 == this.countryCode) {
  //             this.scheduleForm.get("country").setValue(element);
  //           }
  //         });
  //       }
  //     },
  //     (err) => {
  //       this.errorMessage = err.error.message;
  //     }
  //   );
  // }
  // getOnlyState() {
  //   let query =
  //     "filterByDisable=false&orderBy=name&sortBy=1&filterByCountryCode=IN";
  //   this.stateService.getstateList(query).subscribe((res) => {
  //     if (res.data.items.length > 0) {
  //       res.data.items.forEach((element) => {
  //         let stateObj = {
  //           name: element.name,
  //           id: element.id,
  //         };
  //         this.stateList.push(stateObj);
  //       });
  //       this.stateList.forEach((element) => {
  //         if (element.id == this.stateCode) {
  //           this.scheduleForm.get("state").setValue(element);
  //         }
  //       });
  //     }
  //   });
  // }
  // getStates(event) {
  //   this.countryName = event.value.name;
  //   this.countryCode = event.value.iso2;
  //   let query =
  //     "filterByDisable=false&orderBy=name&sortBy=1&filterByCountryCode=" +
  //     this.countryCode;
  //   this.stateService.getstateList(query).subscribe((res) => {
  //     if (res.data.items.length > 0) {
  //       res.data.items.forEach((element) => {
  //         let stateObj = {
  //           name: element.name,
  //           id: element.id,
  //         };
  //         this.stateList.push(stateObj);
  //       });
  //       this.stateList.forEach((element) => {
  //         if (element.id == this.stateCode) {
  //           this.scheduleForm.get("state").setValue(element);
  //         }
  //       });
  //     }
  //   });
  // }
  // setState(event) {
  //   this.stateCode = event.value.id;
  //   this.stateName = event.value.name;
  //   this.cityList=[]
  //   this.getCities(this.stateCode);
  // }
  // getCities(stateId) {
  //   let query =
  //     "?filterByStatus=true&filterByDisable=false&orderBy=name&sortBy=1&filterByStateId=" +
  //     stateId;
  //   this.cityService.getcityList(query).subscribe((res) => {
  //     if (res.data.items.length > 0) {
  //       res.data.items.forEach((element) => {
  //         let cityObj = {
  //           name: element.name,
  //           code: element.name,
  //         };
  //         this.cityList.push(cityObj);
  //       });
  //       this.cityList.forEach((element) => {
  //         if (element.code == this.cityCode) {
  //           this.scheduleForm.get("city").setValue(element);
  //         }
  //       });
  //     }
  //   });
  // }
  // onCitySelect(event) {
  //   this.selectedCityId = undefined;
  //   this.selectedCityName = undefined;
  //   if (event.value) {
  //     console.log(event)
  //     this.selectedCityId = event.value.code;
  //     this.selectedCityName = event.value.name;
  //   }
  // }

  onCitySelect(event) {
    this.selectedCityId = undefined;
    this.selectedCityName = undefined;
    if (event.value) {
      this.selectedCityId = event.value.code;
      this.selectedCityName = event.value.name;
    }
  }
  getStates() {
    this.stateList = [];
    this.stateCode = "";
    this.stateName = "";
    this.cityList = [];
    this.cityCode = "";
    this.cityName = "";
    let countryCode = "IN";
    let query =
      "filterByDisable=false&orderBy=name&sortBy=1&filterByCountryCode=" +
      countryCode;
    this.stateService.getstateList(query).subscribe((res) => {
      if (res.data.items.length > 0) {
        res.data.items.forEach((element) => {
          let stateObj = {
            name: element.name,
            id: element.id,
          };
          this.stateList.push(stateObj);
        });
      }
    });
  }

  getCities(fromForm, event) {
    this.cityCode = "";
    this.cityName = "";
    if (fromForm == "true") {
      //console.log(event);
      this.stateCode = event.value.id;
      this.stateName = event.value.name;
    } else {
      this.stateCode = event;
    }

    this.commonService.getCityList(this.stateCode).subscribe(
      (data) => {
        this.cityList = data.data.items;
      },
      (err) => {
        // this.errorMessage = err.error.message;
      }
    );
  }
  findIndexById(id, arrayName) {
    let index = -1;
    for (let i = 0; i < arrayName.length; i++) {
      if (arrayName[i].id === id) {
        index = i;
        break;
      }
    }
    return index;
  }
  findIndexBySlug(slug, arrayName) {
    let index = -1;
    for (let i = 0; i < arrayName.length; i++) {
      if (arrayName[i].slug === slug) {
        index = i;
        break;
      }
    }
    return index;
  }
  onClickAmenities(amenities, event) {
    console.log(amenities)
    console.log(this.selectedAmenities)
    let slug = amenities.slug;
    let obj = {
      slug: amenities.slug,
      status: true,
    };
    if (amenities.selected == false) {
      this.amenitiesArray.forEach((element) => {
        if (element.slug == amenities.slug) {
          element["selected"] = true;
        }
      });
      this.selectedAmenities.push(obj);
    } else {
      //console.log("No");
      let index = this.findIndexBySlug(amenities.slug, this.selectedAmenities);
      let amenitiesIndex = this.findIndexBySlug(
        amenities.slug,
        this.amenitiesArray
      );
      if (amenitiesIndex != -1) {
        this.amenitiesArray[amenitiesIndex]["selected"] = false;
      }
      if (index != -1) {
        this.selectedAmenities.splice(index, 1);
      }
    }
  }
  onSelectDate(event) {
    this.SelectedDate = moment(event).format("DD-MM-YYYY");

    //console.log("SelectedDate", SelectedDate);

    let todaysDate = new Date();
    if (this.SelectedDate == moment(todaysDate).format("DD-MM-YYYY")) {
      this.minTime = moment(todaysDate).add(2, "hours").local().format();
      this.minTime = new Date(this.minTime);
    } else {
      this.minTime = new Date();
      this.minTime.setHours(0);
      this.minTime.setMinutes(0);
    }
    this.scheduleForm.controls["time"].reset();
  }

  onClickCreateSchedule() {
    this.scheduleForm.reset();
    this.scheduleForm.get("date").enable();
    this.scheduleForm.get("time").enable();
    this.cityList = []
    this.stateList = []
    this.getStates();
    this.recurringDisabled = true;
    //console.log("AmenitiesArray", this.amenitiesArray);
    this.amenitiesArray.forEach((aElement) => {
      aElement["selected"] = false;
    });
    this.selectedAmenities = [];
    this.header = "Create Schedule";
    this.showCreateScheduleForm = true;
  }

  onRecurringCheckboxSelect(recurring, event) {
    let obj = {
      slug: recurring.slug,
      value: recurring.value,
    };
    if (recurring.value === 'daily' && event.checked) {
      // Uncheck and disable other checkboxes if "Daily" is selected
      this.recurringArray
        .filter(recurring => recurring.value !== 'daily')
        .forEach(recurring => {
          const control = this.scheduleForm.get(recurring.slug);
          if (control) {
            control.setValue(false);
            control.disable();
          }
          recurring.status = false;
        });
    } else {
      // Enable all checkboxes if "Daily" is deselected
      this.recurringArray.forEach(recurring => {
        this.scheduleForm.get(recurring.slug)?.enable();
        recurring.status = false;
      });
    }
    if (event.checked) {
      this.recurringArray.forEach((element) => {
        // console.log("element-slug: ", element.slug);
        // console.log("recurring-slug: ", recurring.slug);

        if (element.slug == recurring.slug) {
          element.status = true;
        }
      });
      this.selectedRecurringOptions.push(obj);
    } else {
      this.recurringArray.forEach((element) => {
        if (element.slug == recurring.slug) {
          element.status = false;
        }
      });
      let index = this.findIndexBySlug(
        recurring.slug,
        this.selectedRecurringOptions
      );
      if (index != -1) {
        this.selectedRecurringOptions.splice(index, 1);
      }
    }
  }

  getScheduleList(event: LazyLoadEvent) {

    this.onPageChangeTriggered = false;
    this.lazyLoadEvent = event;
    let pagenumber = 1;
    let params = "";
    let rows = 10;
    //console.log(this.s)
    let query = "?filterByDisable=false&filterByBookingStatus=Pending&filterByStatus=true&filterByStartDate=" +
      moment(this.startDates).startOf('day').utc().format('YYYY-MM-DDTHH:mm');
    if (this.isLoggedIn == true) {
      query += "&filterByUserId=" + this.userId;
      //query += "&filterByUserIdCheck=true";
    }
    if (event !== undefined) {
      if (event.first != undefined && event.first == 0) {
        pagenumber = event.first + 1;
      } else if (event.first != undefined && event.first > 0) {
        pagenumber = event.first / event.rows + 1;
      } else {
        pagenumber = 1;
      }
      if (event.rows != undefined) {
        rows = event.rows;
      } else {
        rows = 10;
      }
    }
    query += "&pageSize=" + rows + "&pageNumber=" + pagenumber + params + "&sortBy=startDate&orderBy=ASC";

    this.scheduleService.getScheduleList(query).subscribe(
      (response) => {
        this.scheduleList = [];
        console.log(this.scheduleList, 'scheduleList')
        //console.log("getScheduleList Function:", response);
        this.scheduleList = response.data.items;
        if (this.scheduleList.length > 0) {
          this.scheduleList.forEach((element) => {
            let startDate = moment(element["startDate"]).utc();
            //element['startDate'] = moment(startDate).format('MMM d, y, h:mm:ss a z');
            // console.log(element.amenities)
            if (element.amenities.length > 0) {
              // element['amenities'];
              this.ament = [];
              element.amenities.forEach((aElement) => {
                this.amenitiesArray.forEach((element) => {
                  // console.log(this.selectedAmenities)
                  if (element.slug == aElement.slug) {
                    this.ament.push(element.name);
                    let obj = {
                      slug: element.slug,
                      status: true,
                    };
                    this.selectedAmenities.push(obj);
                  }
                });

              });
              element["ament"] = this.ament.join(', ');
              // console.log(this.selectedAmenities)
            }
          });
          // this.selectedAmenities=[]
        }
        this.totalRecords = response.data.totalCount;
      },
      (error) => { }
    );
  }
  getScheduleDetails(scheduleId) {
    let query = "?filterByDisable=false&filterByStatus=true";
    this.scheduleId = scheduleId;
    this.scheduleService.getScheduleDetails(scheduleId).subscribe(
      (response) => {
        //console.log("getScheduleDetails: ", response);
        this.scheduleDetails = response;
        this.isAdd = false;
        this.showCreateScheduleForm = true;
        if (this.scheduleDetails) {
          let startDate = moment(this.scheduleDetails["startDate"]);
          let hours = moment(startDate).hours();
          let minutes = moment(startDate).minutes();
          let date = startDate.format("DD-MM-YYYY");
          let dateTime = new Date();
          dateTime.setHours(hours);
          dateTime.setMinutes(minutes);
          this.scheduleForm.get("date").setValue(date);
          //this.scheduleForm.get('time').setValue(dateTime);
          console.log(this.scheduleDetails, 'djdkvjdkvgfjd');

          this.scheduleForm.patchValue({
            venue: this.scheduleDetails["venue"],
            charges: this.scheduleDetails["charges"],
            description: this.scheduleDetails["description"],

            time: dateTime,
          });
          this.scheduleForm.get("state").setValue({
            name: this.scheduleDetails["statename"],
            id: this.scheduleDetails["statecode"],
          });
          this.stateCode = this.scheduleDetails["statecode"];
          this.stateName = this.scheduleDetails["statename"];
          this.selectedCityId = this.scheduleDetails["cityname"];
          this.selectedCityName = this.scheduleDetails["citycode"];
          this.getCities("false", this.scheduleDetails["statecode"]);

          if (this.scheduleDetails["citycode"]) {
            this.scheduleForm.get("city").setValue({
              name: this.scheduleDetails["cityname"],
              code: this.scheduleDetails["citycode"],
            });
          }

          if (this.scheduleDetails.amenities) {
            this.amenitiesArray.forEach((aElement) => {
              aElement["selected"] = false;
            });
            this.scheduleDetails.amenities.forEach((element) => {

              let amenitiesIndex = this.findIndexBySlug(
                element.slug,
                this.amenitiesArray
              );
              if (amenitiesIndex != -1) {
                this.amenitiesArray[amenitiesIndex]["selected"] = true;
                this.selectedAmenities.push(element)
              }
            });
          }
        }
      },
      (error) => { }
    );
  }

  onCreateScheduleModalClose() {
    this.isAdd = true;
    this.scheduleForm.reset();
    this.recurringArray.forEach((element) => {
      element.status = false;
    })
    this.recurringArray = environment.recurringArray;
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    this.router.onSameUrlNavigation = "reload";
    this.router.navigate(["/my-schedule"]);
  }
  onClickEdit(schedule) {
    this.selectedAmenities = []
    this.scheduleForm.get("date").disable();
    this.scheduleForm.get("time").disable();
    this.recurringDisabled = false;
    this.isAdd = false;
    this.header = "Update Schedule";

    this.getScheduleDetails(schedule.id);
  }

  onClickDelete(schedule) {
    this.deleteSheduleModal = true
    this.scheduleDataDetails = schedule
  }
  onClickConfirmDelete() {
    let disableStatus;
    if (this.scheduleDataDetails.disable == false) {
      disableStatus = true;
    } else {
      disableStatus = false;
    }
    let isWeek = false;
    let isMonth = false;
    let isAll = false;
    if (this.selectedCities != undefined) {
      this.selectedCities.forEach(type => {
        if (type.name == "Every Week") {
          isWeek = true;
          this.everyWeek = true

        }
        if (type.name == "Every Month") {
          isMonth = true;
          this.everyMonth = true

        }

        if (type.name == "All Sessions") {
          isAll = true;
        }
      })
    }
    let updatedata =
      '{"disable":' + disableStatus + ',"bookingStatus":"Cancelled","isEveryWeek":' + isWeek + ',"isEveryMonth":' + isMonth + ',"isAll":' + isAll + "}";
    this.scheduleService.updateSchedule(this.scheduleDataDetails.id, updatedata).subscribe(
      (data) => {
        this.messageService.add({
          key: "toastmsg",
          severity: "success",
          summary: " Deleted ",
          detail: "Schedule has been deleted successfully ",
          life: 3000,
        });
        setTimeout(() => {
          this.router.routeReuseStrategy.shouldReuseRoute = () => false;
          this.router.onSameUrlNavigation = "reload";
          this.router.navigate(["/my-schedule"]);
        }, 3000);
        this.getScheduleList(this.lazyLoadEvent);
      },
      (err) => {
        this.errorMessage = err.error.message;
      }
    );

  }

  onSelectionChange() {
    if (this.selectedCities.length < 1) {
      this.messageConfirmation = "Delete schedule sessions";

    }
    if (this.selectedCities.some(city => city.name === 'All Sessions')) {
      // "All Sessions" is selected, unselect "Every Week" and "Every Month"
      this.selectedCities = this.selectedCities.filter(city => city.name === 'All Sessions');
      this.messageConfirmation = "Are you sure you want to delete all schedule sessions from " + moment(this.scheduleDataDetails.startDate).format("DD/MM/Y") + " ?";
    }

    if (this.selectedCities.some(city => city.name === 'Every Week')) {
      this.everyWeek = true
    }
    else {
      this.everyWeek = false
    }
    if (this.selectedCities.some(city => city.name === 'Every Month')) {
      this.everyMonth = true
    }
    else {
      this.everyMonth = false
    }
    if (this.everyWeek == true && this.everyMonth == true) {
      this.messageConfirmation = "Do you want to delete the sessions scheduled for every month on the " + moment(this.scheduleDataDetails.startDate).format('Do') + " and every " + moment(this.scheduleDataDetails.startDate).format("dddd") + " for time slot " + moment(this.scheduleDataDetails.startDate).format('LT') + " to " + moment(this.scheduleDataDetails.endDate).format('LT') + ", from " + moment(this.scheduleDataDetails.startDate).format('ll') + " ?";
      this.everyMonth = false;
      this.everyWeek = false;
    } else if (this.everyWeek == true && this.everyMonth == false) {
      this.messageConfirmation = "Do you want to delete the " + moment(this.scheduleDataDetails.startDate).format("dddd") + " sessions scheduled every week for time slot " + moment(this.scheduleDataDetails.startDate).format('LT') + " to " + moment(this.scheduleDataDetails.endDate).format('LT') + ", from " + moment(this.scheduleDataDetails.startDate).format('ll') + " ?"
    } else if (this.everyMonth == true) {
      this.messageConfirmation = "Do you want to delete the sessions scheduled every month on " + moment(this.scheduleDataDetails.startDate).format('Do') + " for time slot " + moment(this.scheduleDataDetails.startDate).format('LT') + " to " + moment(this.scheduleDataDetails.endDate).format('LT') + ", from " + moment(this.scheduleDataDetails.startDate).format('ll') + " ?";

    }

  }
  onCloseClick() {
    this.selectedCities = null
    this.messageConfirmation = "Delete schedule sessions";

  }
  confirm1() {
    this.confirmationService.confirm({
      accept: () => {
        this.messageService.add({ severity: 'info', summary: 'Confirmed', detail: 'You have accepted' });
      },
      reject: (type: ConfirmEventType) => {
        switch (type) {
          case ConfirmEventType.REJECT:
            this.messageService.add({ severity: 'error', summary: 'Rejected', detail: 'You have rejected' });
            break;
          case ConfirmEventType.CANCEL:
            this.messageService.add({ severity: 'warn', summary: 'Cancelled', detail: 'You have cancelled' });
            break;
        }
      }
    });
  }
  onSubmit() {
    this.submitted = true;
    //stop here if form is invalid
    if (this.scheduleForm.invalid) {
      return;
    }
    let scheduleData = this.scheduleForm.value;
    //console.log("scheduleFormData:- ", this.scheduleForm.value);
    scheduleData["countryname"] = this.countryName;
    scheduleData["countrycode"] = this.countryCode;
    scheduleData["statename"] = this.stateName;
    scheduleData["statecode"] = this.stateCode;
    scheduleData["cityname"] = this.selectedCityName;
    scheduleData["citycode"] = this.selectedCityId;
    scheduleData["userId"] = this.userId;
    scheduleData["amenities"] = this.selectedAmenities;
    // scheduleData["description"] = this.selectedAmenities;


    //console.log("amenities:- ", scheduleData["amenities"]);
    let hours = moment(scheduleData["time"]).hours();
    let minutes = moment(scheduleData["time"]).minutes();
    let date = moment(scheduleData["date"])
      .set("hours", hours)
      .set("minute", minutes);
    //scheduleData["startDate"] = date.format("DD-MM-yyyy HH:mm");
    var startDate1 = moment.tz(moment(date).format('YYYY-MM-DD HH:mm'), 'YYYY-MM-DD HH:mm Z', moment.tz.guess());

    scheduleData["startDate"] = startDate1;
    // scheduleData["currentDate"] = moment()
    //   .set("hours", hours)
    //   .set("minute", minutes)
    //   .format("DD-MM-yyyy HH:mm");
    let currentdt = moment().set("hours", hours).set("minute", minutes).format("DD-MM-yyyy HH:mm");
    var currentdt1 = moment.tz(moment(currentdt).format('YYYY-MM-DD HH:mm'), 'YYYY-MM-DD HH:mm Z', moment.tz.guess());
    scheduleData["currentDate"] = currentdt1
    //scheduleData['amenities'] = this.selectedAmenities;
    scheduleData["isToday"] = this.recurringArray[0]["status"];
    scheduleData["isTomorrow"] = this.recurringArray[1]["status"];
    scheduleData["isEveryWeek"] = this.recurringArray[2]["status"];
    scheduleData["isEveryMonth"] = this.recurringArray[3]["status"];
    scheduleData["isDaily"] = this.recurringArray[4]["status"];
    delete scheduleData["country"];
    delete scheduleData["state"];
    delete scheduleData["city"];
    delete scheduleData["date"];
    delete scheduleData["ball"];
    delete scheduleData["court"];
    delete scheduleData["every_month"];
    delete scheduleData["every_week"];
    delete scheduleData["time"];
    delete scheduleData["tennis_racket"];
    delete scheduleData["today"];
    delete scheduleData["tomorrow"];
    if (this.isAdd) {
      //console.log("I am here");
      scheduleData = JSON.stringify(scheduleData, null, 4);
      //console.log("Schedule Data:- ", scheduleData);
      this.addSchedule(scheduleData);
    } else {
      delete scheduleData["userId"];
      delete scheduleData["startDate"];
      delete scheduleData["isToday"];
      delete scheduleData["isTomorrow"];
      delete scheduleData["isEveryWeek"];
      delete scheduleData["isEveryMonth"];
      scheduleData = JSON.stringify(scheduleData, null, 4);
      // return
      this.updateSchedule(scheduleData);
    }
  }
  addSchedule(scheduleData: any) {
    //console.log("Add Schedule Data:- ", scheduleData);
    //console.log("add");
    this.scheduleService.addSchedule(scheduleData).subscribe(
      (res) => {
        //console.log("AddSchedule res :- ", res);
        this.messageService.add({ key: 'toastmsg', severity: 'success', summary: 'Successful', detail: 'Schedule Created Successfully', life: 6000 });


        this.scheduleForm.reset();
        this.submitted = false;
        this.showCreateScheduleForm = false;
        this.getScheduleList(this.lazyLoadEvent);
        this.amenitiesArray.forEach((element) => {
          element["selected"] = false;
        });
        this.selectedAmenities = [];
        this.loadViewCalendar();
      },
      (err) => {

        this.messageService.add({
          key: "toastmsg",
          severity: "error",
          summary: err.error.error,
          life: 6000,
        });
        setTimeout(() => {
          this.scheduleForm.reset();
          this.selectedAmenities = [];
          this.recurringArray.forEach((element) => {
            element.status = false;
          })
          this.recurringArray = environment.recurringArray;
          this.router.routeReuseStrategy.shouldReuseRoute = () => false;
          this.router.onSameUrlNavigation = "reload";
          this.router.navigate(["/my-schedule"]);
        }, 4000);
      }
    );
  }
  updateSchedule(scheduleData) {
    this.scheduleService
      .updateSchedule(this.scheduleId, scheduleData)
      .subscribe(
        (res) => {
          this.scheduleForm.reset();
          this.submitted = false;
          this.showCreateScheduleForm = false;
          this.getScheduleList(this.lazyLoadEvent);
          this.amenitiesArray.forEach((element) => {
            element["selected"] = false;
          });
          this.selectedAmenities = [];
          this.loadViewCalendar();
          this.messageService.add({ key: 'toastmsg', severity: 'success', summary: 'Successful', detail: 'Schedule Updated Successfully', life: 6000 });
        },
        (err) => { }
      );
  }
  scheduleHistory() {
    let query =
      "?filterByDisable=false&filterByStatus=true&filterByBookingStatus=Pending&filterByUserId=" +
      this.userId;
    this.scheduleService.getScheduleList(query).subscribe(
      (response) => {
        this.scheduleHistoryListArr = [];
        // console.log()
        this.scheduleHistoryListArr = response.data.items;

        if (this.scheduleHistoryListArr.length > 0) {

          this.scheduleHistoryListArr.forEach((element) => {
            let startDate = moment(element["startDate"]).utc();

            let slotStartHours = moment(element["startDate"]).hours();
            let slotStartMinutes = moment(element["startDate"]).minutes();
            let slotEndHours = moment(element["endDate"]).hours();
            let slotEndMinutes = moment(element["endDate"]).minutes();

            let scheduleDataObj = {
              id: element.id,
              startDate: this.convertToClientTimezone(element.startDate),
              endDate: this.convertToClientTimezone(element.endDate),
              slotStartHours: slotStartHours,
              slotStartMinutes: slotEndMinutes,
              slotEndHours: slotEndHours,
              slotEndMinutes: slotEndMinutes,
            };
            // this.scheduleListArray.push(scheduleDataObj);
            if (element.amenities.length > 0) {
              // element['amenities'];
              this.ament = [];
              element.amenities.forEach((aElement) => {
                this.amenitiesArray.forEach((element) => {
                  if (element.slug == aElement.slug) {
                    this.ament.push(element.name);
                    let obj = {
                      slug: element.slug,
                      status: true,
                    };
                    this.selectedAmenities.push(obj);
                  }
                });
              });
              element["ament"] = this.ament;
            }

            // this.selectedAmenities = [];
          });
        }
      });
  }
  showcalender() {
    this.mobileCalender = true;

  }
  hidecalender() {
    this.mobileCalender = false;

  }

  onShow(schedule: any) {
    schedule.showMore = !schedule.showMore;
}


}
